module.exports = __webpack_public_path__ + "img/TIMES-CIRCLE.b474b779.svg";